import { createContext, useContext } from 'react';

import { WorkflowInstance } from '../../hooks/useGetWorkflowInstance';
import { getWorkflowTransitionProgress } from '../../hooks/useWorkflowTransitionProgress';

type WorkflowTransitionProgressContextValue = {
  showTransitionProgress: (action: string) => void;
};

export const WorkflowTransitionProgressContext = createContext<
  WorkflowTransitionProgressContextValue | undefined
>(undefined);

export const useWorkflowTransitionProgressDialog = ():
  | WorkflowTransitionProgressContextValue
  | undefined => useContext(WorkflowTransitionProgressContext);

export const useShowWorkflowTransitionProgress = (
  workflowInstance?: WorkflowInstance,
): (() => void) | undefined => {
  const transitionProgressDialog = useWorkflowTransitionProgressDialog();
  const action =
    workflowInstance && getWorkflowTransitionProgress(workflowInstance)?.action;

  if (!transitionProgressDialog || !action) return undefined;
  return () => transitionProgressDialog.showTransitionProgress(action);
};
